import { PageHead } from "./PageHead";
import { generateBreadcrumbs } from "@/lib/seo";

interface ProfessionalServiceSEOProps {
  title: string;
  description: string;
  canonical: string;
  serviceName: string;
  serviceDescription: string;
  ogImage?: string;
  keywords?: string;
  path: string;
}

export function ProfessionalServiceSEO({
  title,
  description,
  canonical,
  serviceName,
  serviceDescription,
  ogImage,
  keywords,
  path
}: ProfessionalServiceSEOProps) {
  const professionalServiceSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": serviceName,
    "description": serviceDescription,
    "provider": {
      "@type": "Organization",
      "name": "Cosmos Wave",
      "url": "https://www.cosmos-wave.com",
      "logo": "https://www.cosmos-wave.com/favicon.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "sales",
        "email": "contact@cosmos-wave.com",
        "areaServed": "FR"
      }
    },
    "areaServed": {
      "@type": "Country",
      "name": "France"
    },
    "serviceType": "Amazon Marketing Services",
    "url": canonical
  };

  const breadcrumbs = generateBreadcrumbs(path);

  return (
    <PageHead
      title={title}
      description={description}
      canonical={canonical}
      ogImage={ogImage}
      keywords={keywords}
      pageType="service"
      structuredData={[professionalServiceSchema]}
      breadcrumbs={breadcrumbs}
    />
  );
}